import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CropperPosition, ImageCroppedEvent, ImageCropperComponent, ImageTransform } from 'ngx-image-cropper';
import { combineLatest } from 'rxjs';
import { take } from 'rxjs/operators';
import { dataURItoBlob, maxImageSizeBytes } from 'src/app/globals';
import { UserService } from 'src/app/lib/user/services/user.service';
import { SessionService } from '../../../services/session.service';

@Component({
  selector: 'app-image-upload-dialog',
  templateUrl: './image-upload-dialog.component.html',
  styleUrls: ['./image-upload-dialog.component.scss']
})
export class ImageUploadDialogComponent implements OnInit {

  @ViewChild(ImageCropperComponent) imageCropper: ImageCropperComponent;

  maxWidth: number = 500;

  image64: string = null;
  mediaType: string = null;

  croppedImage: string = null;

  containsChanges: boolean = false;

  _isProceeding: boolean = false;
  set isProceeding(value: boolean) {
    this._isProceeding = value;
  }
  get isProceeding(): boolean {
    return this._isProceeding;
  }

  imageToLarge: boolean = false;
  fileUploaded: boolean = false;

  _transformScale: number = 4;
  set transformScale(value: string) {
    let number = parseFloat(value);
    this._transformScale = number;
    this.transform = {
      scale: (number + 1) / 5
    }
  }
  get transformScale(): string {
    return this._transformScale.toFixed(1);
  }

  public transform: ImageTransform = {
    'scale': 1
  }

  outputBuffer: Blob;

  tempCropper: CropperPosition = {} as CropperPosition;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: ImageUploadDialogComponentInputData,
    private _ref: MatDialogRef<ImageUploadDialogComponent>,
    private _userService: UserService,
    private _sessionService: SessionService
  ) {
    if (data) {
      if (data.image64 && data.mediaType) {
        this.mediaType = data.mediaType;
        this.image64 = data.image64;
      }
    }
  }

  close() {
    this._ref.close();
  }

  confirm() {
    if (this.outputBuffer) {
      this.isProceeding = true;
      let data = new FormData();
      data.append(this.data.imageRole, this.outputBuffer, this.data.imageRole);
      data.append('userId', this.data.userId);
      combineLatest([this._sessionService.user$.pipe(take(1)), this._userService.uploadUserImage(data)]).pipe(take(1)).subscribe(([user, Object]) => {
        this.isProceeding = false;
        var reader = new FileReader();
        
        let callback = (base64data: string) => {

          let regex = /^\s*data:(?<media_type>(?<mime_type>[a-z\-]+\/[a-z\-\+]+)(?<params>(;[a-z\-]+\=[a-z\-]+)*))?(?<encoding>;base64)?,(?<data>[a-z0-9\!\$\&\'\,\(\)\*\+\,\;\=\-\.\_\~\:\@\/\?\%\s]*\s*)$/i;
          let result = regex.exec(base64data);

          user.profilePicture = result.groups.data;
          user.profilePictureMediaType = result.groups.mime_type;

          this._sessionService.updateUser(user);

          this._ref.close();
        }

        reader.onloadend = function () {
          var base64data = reader.result;
          callback(base64data as string);
        }

        reader.readAsDataURL(this.outputBuffer);
      })
    }
  }

  cropImage() {
    this.isProceeding = true;
    setTimeout(() => this.imageCropper.crop(), 100);
  }

  fileChangeEvent(event: Event): void {
    if (event && event.target && (event.target as HTMLInputElement).files && (event.target as HTMLInputElement).files.length > 0) {
      this.isProceeding = true;
      let fileReader = new FileReader();
      fileReader.onload = () => {
        this.image64 = fileReader.result as string;
        this.mediaType = ((event.target as HTMLInputElement).files as FileList)[0].type;
        this.croppedImage = null;
        this.isProceeding = false;
        this.fileUploaded = true;
      }
      fileReader.readAsDataURL((event.target as HTMLInputElement).files[0]);
    } else {
      this.fileUploaded = false;
    }
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
    this.tempCropper = event.cropperPosition;
    this.containsChanges = this.croppedImage != this.data.image64;
    if (this.croppedImage) {
      let blob = dataURItoBlob(this.croppedImage);
      this.imageToLarge = maxImageSizeBytes <= blob.size;
      this.isProceeding = false;
      if (!this.imageToLarge) this.outputBuffer = blob;
    }
  }

  ngOnInit(): void {
  }

  switchToCroppingMode() {
    this.isProceeding = true;
    setTimeout(() => {
      this.croppedImage = null;
      this.tempCropper = {
        x1: this.tempCropper.x1,
        x2: this.tempCropper.x2,
        y1: this.tempCropper.y1,
        y2: this.tempCropper.y2
      };
      this.isProceeding = false;
    }, 100);
  }

}

export class ImageUploadDialogComponentInputData {
  image64: string;
  mediaType: string;
  imageRole: 'bannerPicture' | 'profilePicture';
  userId: string;
}
